module.exports = __webpack_public_path__ + "img/60024.d59e0a84.png";